const rankingItems = [
  {
    rank: 1,
    title: '《星际征途：新纪元》',
    tag: '科幻',
    heat: '今日播放 8.6w',
    badge: 'HOT',
  },
  {
    rank: 2,
    title: '《长安风云录》',
    tag: '古装',
    heat: '今日播放 7.9w',
    badge: 'NEW',
  },
  {
    rank: 3,
    title: '《暗夜追踪》第三季',
    tag: '悬疑',
    heat: '今日播放 6.8w',
    badge: 'HOT',
  },
  {
    rank: 4,
    title: '《首尔之恋》',
    tag: '韩剧',
    heat: '今日播放 5.4w',
    badge: '',
  },
  {
    rank: 5,
    title: '《声动亚洲》',
    tag: '综艺',
    heat: '今日播放 4.9w',
    badge: 'NEW',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门榜单
          </h2>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 md:px-8 py-4 md:py-5 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <span className={`font-heading text-xl md:text-2xl font-extrabold w-8 text-center shrink-0 ${
                item.rank === 1 ? 'text-accent-500' :
                item.rank === 2 ? 'text-primary-500' :
                item.rank === 3 ? 'text-secondary-500' :
                'text-foreground-400'
              }`}>
                {item.rank.toString().padStart(2, '0')}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</h3>
                  {item.badge && (
                    <span className={`whitespace-nowrap px-1.5 py-0.5 rounded text-[10px] font-bold ${
                      item.badge === 'HOT' ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-700'
                    }`}>
                      {item.badge}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.heat}</span>
                </div>
              </div>
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-400 hover:bg-primary-500 hover:text-white transition-all cursor-pointer shrink-0">
                <i className="ri-play-fill text-lg"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}